module.exports = __webpack_public_path__ + "img/zhubiao2.1d1b4c63.webp";